<script setup>
import { computed } from 'vue'
import ChartView from '@/components/charts/ChartView.vue'
import { store } from '@/store/appStore.js'

const bp = computed(() => store.salesSupervisorV2.businessPotential.value)
const rows = computed(() => [...bp.value.rows].sort((a,b) => b.opportunityGap - a.opportunityGap))
const segChart = computed(() => ({
  labels: Object.keys(bp.value.segmentation),
  datasets: [{ data: Object.values(bp.value.segmentation), backgroundColor: ['#5B4E9E','#C99A2E','#8B959B','#92583A'] }]
}))
function growthLabel(pct) {
  if (pct === null) return { text: 'New', cls: '' }
  if (pct > 0) return { text: `+${pct}%`, cls: 'color:var(--status-green);font-weight:700;' }
  if (pct < 0) return { text: `${pct}%`, cls: 'color:var(--status-red);font-weight:700;' }
  return { text: '0%', cls: 'color:var(--color-text-muted);' }
}
</script>

<template>
  <div>
    <div class="card module-header"><h2>Team Business Potential</h2></div>

    <div class="split-side-main" style="margin-bottom:16px;">
      <div class="card" style="padding:18px;"><div class="eyebrow" style="margin-bottom:8px;">Segmentation</div><ChartView type="doughnut" :labels="segChart.labels" :datasets="segChart.datasets" :height="200" key="ss-bp-seg" /></div>
      <div class="stat-row" style="margin-bottom:0;">
        <div class="card stat-card"><div class="stat-value" style="color:#5B4E9E;">{{ bp.segmentation.Platinum }}</div><div class="stat-label">Platinum</div></div>
        <div class="card stat-card"><div class="stat-value" style="color:#97731f;">{{ bp.segmentation.Gold }}</div><div class="stat-label">Gold</div></div>
        <div class="card stat-card"><div class="stat-value" style="color:#5B6469;">{{ bp.segmentation.Silver }}</div><div class="stat-label">Silver</div></div>
        <div class="card stat-card"><div class="stat-value" style="color:#92583A;">{{ bp.segmentation.Bronze }}</div><div class="stat-label">Bronze</div></div>
      </div>
    </div>

    <div class="card" style="margin-bottom:16px;">
      <div class="toolbar"><span class="result-count">Opportunity Gap by Sales Exec (total: ${{ bp.totalOpportunityGap.toLocaleString() }})</span></div>
      <div class="table-wrap">
        <table class="data-table">
          <thead><tr><th>Sales Exec</th><th>Opportunity Gap</th></tr></thead>
          <tbody>
            <tr v-for="e in bp.byExec" :key="e.execName">
              <td class="cell-strong">{{ e.execName }}</td>
              <td :style="e.opportunityGap>0?'color:var(--color-accent);font-weight:600;':'color:var(--status-green);'">${{ e.opportunityGap.toLocaleString() }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="card">
      <div class="toolbar"><span class="result-count">By Pharmacy</span></div>
      <div class="table-wrap">
        <table class="data-table">
          <thead><tr><th>Pharmacy</th><th>Territory</th><th>Category</th><th>Score</th><th>Class.</th><th>Orders</th><th>Avg Order</th><th>Growth %</th><th>Actual</th><th>Potential</th><th>Opportunity Gap</th></tr></thead>
          <tbody>
            <tr v-for="p in rows" :key="p.customerId">
              <td class="cell-strong">{{ p.pharmacyName }}</td><td class="cell-muted">{{ p.territory }}</td><td class="cell-muted">{{ p.category }}</td>
              <td class="cell-muted">{{ p.potentialScore }}</td>
              <td><span class="tier-badge" :class="p.potentialClassification">{{ p.potentialClassification }}</span></td>
              <td class="cell-muted">{{ p.orderCount }}</td>
              <td class="cell-muted">{{ p.avgOrderValue ? '$'+p.avgOrderValue.toLocaleString() : '—' }}</td>
              <td :style="growthLabel(p.growthPct).cls">{{ growthLabel(p.growthPct).text }}</td>
              <td class="cell-muted">${{ p.actual.toLocaleString() }}</td><td class="cell-muted">${{ p.potentialValue.toLocaleString() }}</td>
              <td :style="p.opportunityGap>0?'color:var(--color-accent);font-weight:600;':'color:var(--status-green);'">{{ p.opportunityGap>0?'$'+p.opportunityGap.toLocaleString():'Realized' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
